@if (pricings) {
  <div class="product-details-pricing-info">
    <h5>
      <span>{{ 'ADVERT.PRICING' | translate }}</span>
    </h5>
    <div>
      @for (data of pricings; track data.id) {
        <div class="description">
          <div>
            <p>{{ data?.timing }} - {{ data?.priceValue }} DKK</p>
          </div>
          <span>{{ data?.serviceDescription }}</span>
        </div>
      } @empty {
        <div class="description">
          <span>{{ 'ADVERT.NO_PRICE' | translate }}</span>
        </div>
      }
    </div>
  </div>
}
